import { render, staticRenderFns } from "./InfoImage.vue?vue&type=template&id=6f493eeb&scoped=true&"
import script from "./InfoImage.vue?vue&type=script&lang=js&"
export * from "./InfoImage.vue?vue&type=script&lang=js&"
import style0 from "./InfoImage.vue?vue&type=style&index=0&id=6f493eeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f493eeb",
  null
  
)

export default component.exports